import {
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

@Component({
    selector: 'fe-precheckin-layout',
    templateUrl: './precheckin-layout.component.html',
    styleUrls: ['./precheckin-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PrecheckinLayoutComponent implements OnInit {
    @Input() indicates = true;
    submitForm = false;
    public conditionExpression!: string;

    public confirmButtonText?: string;
    public cancelButtonText?: string;

    @ViewChild('precheckinTemplate') private precheckinSwal!: SwalComponent;

    constructor(
        private translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.route.url.subscribe((url) => {
            const segments = url.map((segment) => segment.path);
            if (segments.includes('reservacion_activa')) {
                this.conditionExpression = 'reservacion_activa';
            } else if (segments.includes('documentos_oficiales')) {
                this.conditionExpression = 'documentos_oficiales';
            } else if (segments.includes('datos_facturacion')) {
                this.conditionExpression = 'datos_facturacion';
            } else {
                this.conditionExpression = 'default';
            }
        });
    }

    onClick() {
        this.submitForm = true;
        setTimeout(() => (this.submitForm = false), 0);
    }

    onKeydown(event: any) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.onClick();
        }
    }

    swal() {
        const confirmButtonText = this.translate.instant(
            'fe_precheckin_layout_swal_confirm',
        );
        const cancelButtonText = this.translate.instant(
            'fe_precheckin_layout_swal_cancel',
        );

        this.precheckinSwal.update({
            confirmButtonText,
            cancelButtonText,
        });

        this.precheckinSwal.fire().then((result) => {
            if (result.isConfirmed) {
                this.router.navigate(['/']);
            }
        });
    }
}
